import React from 'react';
import './Noticias.css';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

export default function Noticias() {
  return (
    <>
      <div className='news-spec-header'>
        <h1>NOTICIAS</h1>
      </div>
      <div className='news-spec-container'>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box'>
            <div className='news-spec-img-container-l'>
              <img src='images/4b45b457-1842-413a-b482-477ec9247720.jpeg' alt='horario' className='news-spec-img' />
            </div>
          </Box>
        </Container>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box-t'>
            <div className='news-spec-text-container'>
              <h1>Curso intensivo Kungfu Shaolin <b>Forma del Borracho</b></h1>
              <p>📅 6, 7 y 8 Noviembre - 2026</p>
              <p>📍 Chinchilla, Albacete</p>
            </div>
          </Box>
        </Container>
      </div>
      <div className='news-spec-container'>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box'>
            <div className='news-spec-img-container-l'>
              <img src='images/cursointensivotaichi2026.jpeg' alt='horario' className='news-spec-img' />
            </div>
          </Box>
        </Container>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box-t'>
            <div className='news-spec-text-container'>
              <h1>Curso intensivo de Sable de Taichi y Kungfu</h1>
              <p>📅 23 y 24 de Mayo - 2026</p>
              <p>📍 Masia el Molinete</p>
            </div>
          </Box>
        </Container>
      </div>
      <div className='news-spec-container'>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box'>
            <div className='news-spec-img-container-l'>
              <img src='images/seminariotaichichen2026.jpeg' alt='horario' className='news-spec-img' />
            </div>
          </Box>
        </Container>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box-t'>
            <div className='news-spec-text-container'>
              <h1>Seminario de Tai Chi Chen por el Gran Maestro Chen Bing</h1>
              <p><strong>Fechas:</strong> 9 al 13 de septiembre de 2026 - Valencia</p>

              <p>
                El Maestro Chen Bing, descendiente directo del creador del Tai Chi,
                Chen Wangting (20ª generación), impartirá en el Centro Cultural
                Shaolin Valencia un seminario extraordinario y único en España.
              </p>
              <br />
              <p><strong>Programa:</strong></p>
              <p>
                <strong>Miércoles 9 a viernes 11 (18:40 - 21:00)</strong><br />
                Miércoles: Chan Si Gong (movimientos básicos) y Fajing (fuerza instantánea)<br />
                Jueves: Tui Shou (empuje de manos) y aplicaciones a la defensa personal<br />
                Viernes: Conferencia y exhibiciones
              </p>
              <br />
              <p>
                <strong>Sábado 12 y domingo 13</strong><br />
                9:00 - 13:00 y 15:30 - 17:30<br />
                Curso intensivo de Xinjia Yilu
              </p>
              <br />
              <p><strong>Precios:</strong></p>

              <p>
                1 sesión (martes a viernes): 45€<br />
                3 sesiones (martes a viernes): 90€<br />
                Fin de semana: 130€<br />
                Seminario completo (del 9 al 13): 210€
              </p>
              <br />

              <p><strong>Contacto:</strong></p>

              <p>
                WhatsApp: +34 699 17 06 98<br />
                Email: shaolinvalencia@gmail.com<br />
                Web: www.shaolinvalencia.com
              </p>
            </div>
          </Box>
        </Container>
      </div>
      <div className='news-spec-container'>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box'>
            <div className='news-spec-img-container-l'>
              <img src='images/anhonuevochino2026program.jpeg' alt='horario' className='news-spec-img' />
            </div>
          </Box>
        </Container>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box-t'>
            <div className='news-spec-text-container'>
              <h1>Año Nuevo Chino 2026</h1>
            </div>
          </Box>
        </Container>
      </div>
      <div className='news-spec-container'>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box'>
            <div className='news-spec-img-container-l'>
              <img src='images/anhonuevochino2026.jpeg' alt='horario' className='news-spec-img' />
            </div>
          </Box>
        </Container>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box-t'>
            <div className='news-spec-text-container'>
              <h1>Jornada de intercambio cultural y gastronómico Valencia-China</h1>
            </div>
          </Box>
        </Container>
      </div>
      <div className='news-spec-container'>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box'>
            <div className='news-spec-img-container-l'>
              <img src='images/fiestaluna2025.jpeg' alt='horario' className='news-spec-img' />
            </div>
          </Box>
        </Container>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box-t'>
            <div className='news-spec-text-container'>
              <h1>Fiesta de la Luna o del Medio Otoño</h1>
            </div>
          </Box>
        </Container>
      </div>
      <div className='news-spec-container'>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box'>
            <div className='news-spec-img-container-l'>
              <img src='images/act.jpeg' alt='horario' className='news-spec-img' />
            </div>
          </Box>
        </Container>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box-t'>
            <div className='news-spec-text-container'>
              <h1>CHIU CHI LING visita el centro SHAOLIN VALENCIA</h1>
              <p>
                  Hemos tenido el gran honor y placer de contar con la visita del Actor y Maestro de Artes Marciales Chiu Chi Ling que, en su periplo europeo, ha pasado unos días en la ciudad de Valencia, y en su apretada agenda, nos ha obsequiado con una amena tarde en Shaolin Valencia. <br/>
                  Chiu Chi Ling es un reconocido actor que ha compartido pantalla con actores de la talla de Jackie Chan o Jet Li, y que los amantes de las películas de artes marciales recordamos en actuaciones inolvidables como La Serpiente a la Sombra del Aguila (1978) o más reciente en Kung Fu Sion (2004) o en tutoriales como Tiger and Crane Shaolin Kung Fu (1982), que se han convertido en grandes clásicos del cine de Artes Marciales. <br/>
                  El Maestro Chiu Chi Ling es el máximo representante actual del estilo Hung Gar, que aprendió en el seno de su familia bajo la tutela directa de su padre, el Gran Maestro Chiu Kao.
                  Amigo personal del maestro Zhu QiHui, director de Shaolin Valencia, con el que también ha compartido pantalla y coreografía en varias películas en China, ha hecho gala de su enorme vitalidad y condición física durante la vista a Shaolin Valencia, una clara muestra de la excelencia que supone una vida dedicada a la práctica de las Artes Marciales Chinas.<br/>
                  Gracias Maestro Chiu Chi Ling!
                  </p>
            </div>
          </Box>
        </Container>
      </div>
      <div className='news-spec-container'>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box'>
            <div className='news-spec-img-container-l'>
              <img src='images/Anyo_nuevo_chino.jpeg' alt='horario' className='news-spec-img' />
            </div>
          </Box>
        </Container>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box-t'>
            <div className='news-spec-text-container'>
              <h1>Actividades con Shaolin Valencia</h1>
              <h3>Día 14 de Enero — Sábado</h3>
                <ul>
                  <li>Espectáculos en Quart de Poblet, Valencia</li>
                </ul>
              <h3>Día 16 de Enero — Lunes</h3>
                <ul>
                  <li>Espectáculos en Murcia</li>
                </ul>
              <h3>Día 19 de Enero — Jueves</h3>
                <ul>
                  <li>Cabalgata del Año Nuevo Chino en Manises</li>
                </ul>
              <h3>Día 21 de Enero — Sábado</h3>
                <ul>
                  <li>11:00–11:30 — Clase de TaiChi y ChiKung gratuitas</li>
                  <li>12:00–14:00 — Exibiciones de Kung Fu Shaolin, TaiChi, Kung Fu Té, danzas y canciones chinas</li>
                  <li>18:00 — Gran Cabalgata del Año Nuevo Chino</li>
                </ul>
              <h3>Día 22 de Enero — Domingo</h3>
                <ul>
                  <li>11:00–14:00 — Exibiciones en la Calle Pelayo</li>
                </ul>
              <h3>Día 23 de Enero — Lunes</h3>
                <ul>
                  <li>Gran espectáculo en el teatro Liceu, Barcelona</li>
                </ul>
              <h3>Día 26 de Enero — Jueves</h3>
                <ul>
                  <li>Conferencia del Kung Fu Shaolin con el Maestro Zhu en la Facultat de Filología, Traducció i Comunicació, Salón de Grados</li>
                </ul>
            </div>
          </Box>
        </Container>
      </div>
      <div className='news-spec-container'>
        <Container className='news-spec-box-container'>
          <Box className='news-spec-box1'>
            <div className='news-spec-img-container'>
            </div>
          </Box>
        </Container>
      </div>
    </>
  );
}
